import { crmApiInstance } from './client.js';

export const productCostImportApi = {
  upload: (file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    return crmApiInstance.post('/admin/product-cost-import', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300_000,
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
  },
};
